import { NgModule } from '@angular/core';
import { ShopDataAccessModule } from '@shop/data-access';
import { ShopFeatureModule } from '@shop/feature';

@NgModule({
  imports: [ShopDataAccessModule, ShopFeatureModule],
})
export class ShopShellEagerModule {}
